import { GridApiPro, GridGroupNode, GridRowTreeConfig } from "@mui/x-data-grid-premium";

export function gridTreeHasGroups(apiRef: GridApiPro) {
	return Object.entries(apiRef.state.filter.filteredRowsLookup).some(
		([id, isFiltered]) => isFiltered && apiRef.state.rows.tree[id]?.type === "group"
	);
}

export function gridTreeHasSomeRows(apiRef: GridApiPro, predicate: (node: GridGroupNode) => boolean) {
	const state = apiRef.state;
	return state.rows.dataRowIds.some((id) => {
		const node = state.rows.tree[id];
		return node && node.type === "group" && predicate(node);
	});
}

export function gridTreeHasExpandedRows(apiRef: GridApiPro) {
	return gridTreeHasSomeRows(apiRef, (node) => Boolean(node.childrenExpanded));
}

export function gridTreeHasCollapsedRows(apiRef: GridApiPro) {
	return gridTreeHasSomeRows(apiRef, (node) => !node.childrenExpanded);
}

export function toggleGridTreeRowExpansion(apiRef: GridApiPro, isExpanded: boolean) {
	let lastUpdatedNode: GridGroupNode | undefined;
	// Instead of triggering re-renders for each rowGroup with apiRef.current.setRowChildrenExpansion, we update the state once and then force an update
	apiRef.setState((state) => ({
		...state,
		rows: {
			...state.rows,
			tree: Object.keys(state.rows.tree).reduce((newState, rowId) => {
				const originalNode = state.rows.tree[rowId];
				if (originalNode.type === "group") {
					const newGroupNode = {
						...originalNode,
						childrenExpanded: isExpanded,
					};
					newState[rowId] = newGroupNode;
					lastUpdatedNode = newGroupNode;
				} else {
					newState[rowId] = originalNode;
				}
				return newState;
			}, {} as GridRowTreeConfig),
		},
	}));

	if (lastUpdatedNode) {
		apiRef.forceUpdate();
		apiRef.publishEvent("rowExpansionChange", lastUpdatedNode);
	}
}

export function countHiddenRows(apiRef: GridApiPro) {
	return Object.values(apiRef.state.visibleRowsLookup).reduce((acc, isVisible) => acc + (!isVisible ? 1 : 0), 0);
}

export function countVisibleRows(apiRef: GridApiPro) {
	return apiRef.state.rows.totalRowCount - countHiddenRows(apiRef);
}
